<template>
    <div class="global-rating-block">
        <div class="global-rating-star" v-for="i in 5" :key="i">
            <div :class="'global-rating-el ' + (i < Math.floor(avg) + 1 ? 'global-rating-active' : '')">
                <div v-if="avg > (i - 1) && avg < i" :style="{width: widthActiveStar + '%'}" class="global-rating-float">
                    <i class="fa fa-star"></i>
                </div>
                <i class="fa fa-star"></i>
            </div>
        </div>
        <span v-if="!without_avg">{{ parseFloat(avg).toFixed(2) }}</span>
        <p v-if="count_text">{{ count_text }}</p>
    </div>
</template>

<script>
    export default {
        props: [
            'avg', 'count_text', 'without_avg'
        ],
        data: function () {
            return {
                widthActiveStar: ((this.avg - Math.floor(this.avg)) * 100)
            }
        }
    }
</script>
